import { useEffect, useRef, useState } from "react";

const UserPopUp = (props) => {
  const popupref = useRef(null);
  const inputref = useRef(null);
  const [search, setsearch] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  // Reset the filter each time the popup opens, and focus the input so the
  // user can start typing a name immediately instead of scrolling.
  useEffect(() => {
    if (props.visible) {
      setsearch("");
      // Defer focus until after the popup paints.
      const id = setTimeout(() => inputref.current?.focus(), 0);
      return () => clearTimeout(id);
    }
  }, [props.visible]);

  const fullName = (item) =>
    `${item.firstname || ""} ${item.lastname || ""}`.trim();

  const sorted = [...(props.data || [])].sort((a, b) =>
    fullName(a).toLowerCase().localeCompare(fullName(b).toLowerCase()),
  );

  const term = search.trim().toLowerCase();
  const filtered = term
    ? sorted.filter((item) => fullName(item).toLowerCase().includes(term))
    : sorted;

  return (
    props.visible && (
      <div
        ref={popupref}
        className={`w-[250px]

         bg-white border border-gray-300 rounded-md overflow-y-scroll gk-scr p-[10px] position absolute z-10  top-[50px] left-[0px]  self-start`}
        style={props.style}
      >
        <input
          ref={inputref}
          type="text"
          value={search}
          placeholder="Search by name"
          onChange={(event) => setsearch(event.target.value)}
          className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-2 rounded-xl border border-themeColor items-center flex mb-[10px]"
        />
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {filtered.length === 0 ? (
            <p className="font-medium PoppinsRegular text-sm text-gray-400 ml-[10px] py-[5px]">
              No matches
            </p>
          ) : (
            filtered.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  props.onClickcorrect(item);
                }}
                className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl`}
              >
                <p className=" font-medium PoppinsRegular text-sm ml-[10px]">
                  {item.firstname + " " + item.lastname}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    )
  );
};

export default UserPopUp;
